module.exports = __webpack_public_path__ + "static/media/IMG_20200717_214513_784_tn.988230cc.jpg";